// src/components/onboarding/screens/AttentesScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { CheckboxItem, ScreenTitle } from '../OnboardingUI';
import { attentesOptions, TOTAL_STEPS } from '../onboardingData';

const AttentesScreen = ({ attentes, onChange, onNext, loading, error }) => {
  const toggleAttente = (value) => {
    if (attentes.includes(value)) {
      onChange(attentes.filter(v => v !== value));
    } else if (attentes.length < 3) {
      onChange([...attentes, value]);
    }
  };

  const canProceed = attentes.length > 0;

  return (
    <OnboardingLayout
      currentStep={5}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle
        title="Qu'est-ce qui pourrait t'intéresser ici ?"
        subtitle="Choisis 1 à 3 trucs"
      />

      <div className="flex-1 overflow-y-auto mb-4">
        {attentesOptions.map(option => (
          <CheckboxItem
            key={option}
            checked={attentes.includes(option)}
            label={option}
            onClick={() => toggleAttente(option)}
            disabled={loading || (attentes.length >= 3 && !attentes.includes(option))}
          />
        ))}
      </div>
    </OnboardingLayout>
  );
};

export default AttentesScreen;
